<template>
    <div class="flex items-center justify-center h-screen" style="height: 100dvh">
        <div class="flex flex-col items-center justify-center">
            <div
                :class="layoutConfig.isDarkTheme.value ? 'bg-black' : 'bg-white'"
                class="rounded-xl p-1 bg-gradient-to-b from-red-500 to-transparent"
            >
                <div
                    :class="layoutConfig.isDarkTheme.value ? 'bg-black' : 'bg-white'"
                    class="w-full py-8 px-5 sm:px-8 flex flex-col items-center rounded-xl max-h-[90vh] max-w-[90vw] mx-auto"
                >
                    <div class="grid flex flex-col items-center text-center">
                        <i
                            class="fal fa-exclamation-circle text-5xl text-white"
                            style="color: red"
                        ></i>
                        <h1 class="font-bold text-3xl mb-2">
                            {{ $t(title) }}
                        </h1>
                        <div class="mb-5">
                            <span style="white-space: pre-line">
                                {{ $t(subTitle) }}
                            </span>
                        </div>
                        <div
                            :class="NODE_ENV == 'development' ? '' : 'hidden'"
                            class="border-2 border-red-500 p-3 mb-5 w-full rounded-lg bg-red-50 text-red-500 text-xl font-bold"
                        >
                            <br />
                            {{ error }}
                            <br />
                            <br />
                        </div>
                        <div class="flex justify-center">
                            <img src="/error.webp" alt="Error" class="mb-5" width="350px" />
                        </div>
                        <div class="w-full text-center">
                            <NuxtLink
                                :to="
                                    props.error.statusCode && !token
                                        ? '/'
                                        : props.error.statusCode && token && checkToken
                                        ? ((menu || [])[0] || {}).route || '/'
                                        : '/'
                                "
                            >
                                <Button
                                    :label="
                                        props.error.statusCode && !token
                                            ? $t('error_effettua_login')
                                            : props.error.statusCode && token && checkToken
                                            ? $t('error_torna_pagina_iniziale')
                                            : $t('error_effettua_login')
                                    "
                                    class="bg-red-500 text-white hover:bg-red-600"
                                    style="border: unset !important"
                                    icon="fal fa-arrow-left"
                                ></Button>
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useLayout } from './layouts/composables/layout';

const { layoutConfig } = useLayout();
const { $localStorage } = useNuxtApp();
const props = defineProps(['error']);
const config = useRuntimeConfig();
const BASE_PROGETTO = config.public.base_progetto;
const token = useCookie(`token${config.public.base_progetto}`).value;
const NODE_ENV = process.config.NODE_ENV;

const title =
    props.error.statusCode === 404
        ? 'error_titolo_404'
        : props.error.statusCode === 401
        ? 'error_titolo_401'
        : 'error_titolo_generale';
const subTitle =
    props.error.statusCode === 404
        ? 'error_sottotitolo_404'
        : props.error.statusCode === 401
        ? 'error_sottotitolo_401'
        : 'error_sottotitolo_generale';
const checkToken = ref(false);
const menu = JSON.parse($localStorage.getItem('menu') || null) || [];

onMounted(async () => {
    const token = useCookie(`token${BASE_PROGETTO}`).value;

    if (isString(token)) {
        await $fetch('/api/general/checkToken', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + useCookie(`token${BASE_PROGETTO}`).value,
            },
        })
            .then((response) => {
                checkToken.value = response;
            })
            .catch(() => {
                navigateTo('/', { replace: true });
            });
    } else {
        navigateTo('/', { replace: true });
    }
});
</script>
